import React, { useState, useContext } from "react";
import * as Navigation from "@react-navigation/native";
import withLocalStorage from "../../utils/localStore";
import { createTopic } from '../../graphql/mutations'
import { GetForos } from '../../graphql/queries'
import CreateTopicForum from "../../components/forumComponents/CreateTopicForm";
import moment from 'moment'

import { firestore } from 'firebase'
import AuthContext from "../../context/AuthContext";

const CreateTopicPage = ({ id, filtro, navigation, route }) => {


    const {userData} = useContext(AuthContext)
    const [body, setBody] = useState("")
    const [loading, setLoading] = useState(false)
    const [title, setTitle] = useState("")
    const { navigate } = Navigation.useNavigation();
    const forumID = route.params.id



    const sendNewTopic = () => {
        setLoading(true)
        const variables = {
            title,
            body,
            user: {
                id: userData.id,
                name: userData.name,
                image:`${userData.tenants[0].id}/users/${userData.id}/profilePicture`
            },
            tenant: userData.tenants[0].id,
            responses: 1,
            subscribed: firestore.FieldValue.arrayUnion(userData.id),
            forum: firestore().collection("tenants").doc(userData.tenants[0].id).collection("forums").doc(forumID),
            lastActive: firestore.FieldValue.serverTimestamp(),
        }
        firestore().collection("tenants").doc(userData.tenants[0].id).collection("forums").doc(forumID).collection("topics").add(variables)
            .then(ev => {
                navigate("SingleTopic", {
                    id: ev.id,
                    forumID
                })
                setLoading(false)
            })
            .catch(err => {
                alert("Ha ocurrido un error al crear este hilo")
                setLoading(false)
            })
    }

    return <CreateTopicForum title={title} setTitle={title => setTitle(title)} loading={loading} body={body} setBody={body => setBody(body)} sendNewTopic={() => sendNewTopic()} styles={styles} />;
};

const styles = {
    btn: {
        height: 35,
        width: 100,
        borderWidth: 1,
        borderColor: "gainsboro",
        borderRadius: 4,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
    }
}

export default withLocalStorage(CreateTopicPage)